export const provisos = {
  customComponents: child => typeof child.type !== 'string'
}
